const LottiePlayer = () => {
  // FIXME: This is a temporary fix for the lottie player issue / remove lottie
  return <div style={{ height: `100%`, width: '100%' }} />
}

export default LottiePlayer
